// PurchaseModal.jsx
import { useModal } from "../../contexts/ModalContext";
import { useUser } from "../../contexts/UserContext";
import { ItemData } from "@mythic/pixl";

import "./PurchaseModal.css";

interface Props {
    category: string;
    item: ItemData;
    onPurchase: (json: any) => void;
    onTry: (item: ItemData) => void;
}

export default function PurchaseModal({
    category,
    item,
    onPurchase,
    onTry,
}: Props) {
    // The purchase modal needs to be able to hide itself.
    const hideModal = useModal()?.hideModal;

    // coins is required as the modal shows the user their balance.
    const { user, coins } = useUser();

    const handleConfirm = () => {
        // When the user confirms, create the
        // POST body
        if (!user) return;

        const opts: RequestInit = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // FIXME: This is a vulnerability. The user could alter
                // the item price here and pay a cheaper price. The price
                // should instead be gathered on the NodeJS server using
                // the customization.json file.
                amount: item.price,

                // This is for Streamer.bot to log the reason for the
                // coins to be spent.
                reason: `purchased ${item.name}`,

                // avatar_item tells the server that the user is spending
                // coins to purchase an avatar item. Removing this will
                // prevent the user from receiving their item.
                type: "avatar_item",

                // This is the data the user actually receives to their account
                purchase: { category: category, id: item.id, purchase_date: 0 },
            }),
        };

        // Send the request to spend the coins.
        fetch(
            `${import.meta.env.VITE_SERVER_URL || ""}/api/avatars/${user?.id}/purchaseItem`,
            opts,
        )
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                // If the status returns as ok, the user has purchased the
                // item successfully.
                if (json.status === "ok") {
                    onPurchase(json);
                }
            })
            .catch((err) => console.error("Failed to log out:", err));

        if (hideModal) hideModal();
    };

    const handleTry = () => {
        onTry(item);
        if (hideModal) hideModal();
    };

    // Below there are several {" "} lines. This is to ensure a space
    // is inserted between the preceeding word and the following span.
    return (
        <div className="purchase-modal">
            <h2 className="modal-title">Purchase {item.name}?</h2>
            <div className="modal-body">
                <p>
                    You do not currently own{" "}
                    <span
                        style={{ fontWeight: "bold", color: "var(--accent-b)" }}
                    >
                        {item.name}
                    </span>
                    .<br></br>This item costs{" "}
                    <span
                        style={{ fontWeight: "bold", color: "var(--accent-b)" }}
                    >
                        {item.price}
                    </span>{" "}
                    Soul Coins.<br></br>
                    You have{" "}
                    <span
                        style={{ fontWeight: "bold", color: "var(--accent-b)" }}
                    >
                        {coins}
                    </span>{" "}
                    Soul Coins.
                    <br></br>Would you like to purchase?
                </p>
                <button onClick={handleConfirm} style={{ marginRight: "4px" }}>
                    Confirm
                </button>
                <button onClick={handleTry} style={{ margin: "0 4px" }}>
                    Try On
                </button>
                <button onClick={hideModal} style={{ marginLeft: "4px" }}>
                    Cancel
                </button>
            </div>
        </div>
    );
}
